import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../../helpers/reducerRegistry'
import { GDP_TAB } from '../../../constant'

const slice = createSlice({
  name: 'industry/industryOverview/macroeconomics/gdp/gdpChart/chartIndustry',
  initialState: {
    tab: GDP_TAB.REAL_GDP.key,
  },
  reducers: {
    changeTab: (state, action) => {
      state.tab = action.payload
    },
  },
})

export const selectTab = (state) => state[slice.name].tab

export const { changeTab } = slice.actions

register(slice.name, slice.reducer)
